module.exports = __webpack_public_path__ + "bin/97427cc5cc6555f20cffadd0f431c26c.svg";